export default function getTextColor(codename: TextColors) {
  switch (codename) {
    case "white":
      return "text-white";
    case "chocolate":
      return "text-chocolate";
    case "midnight":
      return "text-midnight";
    case "teal":
      return "text-primary";
    case "redwood":
      return "text-redWood";
  }
}

export type TextColors =
  | "white"
  | "chocolate"
  | "midnight"
  | "teal"
  | "redwood";
